export default __webpack_public_path__ + "static/media/art_pallete.de9aec5f.svg";